<template>
    <div>
        <calendar-navigation
            :meta="meta"
            view="year"
            :show-view-switch="showViewSwitch"
            @set-view="setView"
            @set-date="setDate"
        ></calendar-navigation>

        <layout-box>
            <div
                class="grid max-w-3xl grid-cols-1 px-4 py-16 mx-auto gap-x-8 gap-y-16 sm:grid-cols-2 sm:px-6 xl:max-w-none xl:grid-cols-3 xl:px-8 2xl:grid-cols-4"
            >
                <section v-for="month in months" :key="month.name" class="text-center">
                    <h2 class="font-semibold text-gray-900 dark:text-zinc-50">{{ month.name }}</h2>
                    <div class="grid grid-cols-7 mt-6 text-xs leading-6 text-gray-500">
                        <div>P</div>
                        <div>Ú</div>
                        <div>S</div>
                        <div>Č</div>
                        <div>P</div>
                        <div>S</div>
                        <div>N</div>
                    </div>
                    <div
                        class="grid grid-cols-7 gap-px mt-2 text-sm bg-gray-200 rounded-lg shadow isolate ring-1 ring-gray-200 dark:ring-zinc-900 dark:bg-zinc-900"
                    >
                        <button
                            v-for="(day, dayIdx) in month.days"
                            :key="day.date"
                            type="button"
                            class="relative"
                            :class="[
                                day.isCurrentMonth
                                    ? 'bg-white dark:bg-zinc-800 text-gray-900 dark:text-zinc-50'
                                    : 'bg-gray-50 text-gray-400 dark:bg-zinc-700',
                                dayIdx === 0 && 'rounded-tl-lg',
                                dayIdx === 6 && 'rounded-tr-lg',
                                dayIdx === month.days.length - 7 && 'rounded-bl-lg',
                                dayIdx === month.days.length - 1 && 'rounded-br-lg',
                                'py-1.5 hover:bg-gray-100 focus:z-10',
                            ]"
                            @click="openDate(day)"
                        >
                            <div class="absolute flex space-x-1 bottom-1 left-1">
                                <span
                                    v-for="(event, eventIndex) in day.events"
                                    :key="eventIndex"
                                    class="inline-block w-1.5 h-1.5 rounded-full"
                                    :class="`bg-${event.color}-700`"
                                ></span>
                            </div>
                            <time
                                :datetime="day.date"
                                :class="[
                                    day.isToday && 'bg-brand-600 font-semibold text-white',
                                    'mx-auto flex h-7 w-7 items-center justify-center rounded-full',
                                ]"
                                >{{ day.date.split('-').pop().replace(/^0/, '') }}</time
                            >
                        </button>
                    </div>
                </section>
            </div>
        </layout-box>
    </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import CalendarNavigation from '@src/Reservations/Pages/Calendar/Partials/Navigation.vue';

const props = defineProps({
    date: {
        type: Object,
        default: () => ({
            day: null,
            month: null,
            year: null,
        }),
    },
    showViewSwitch: {
        type: Boolean,
        default: true,
    },
});

const showViewSwitch = ref(props.showViewSwitch);

const emit = defineEmits(['setView', 'setDate']);

const setView = (view: string) => emit('setView', view);

const months = ref([]);
const meta = ref({});

const getData = ({ day, month, year } = { day: null, month: null, year: null }) => {
    axios
        .get(route('reservations.calendar.api.year'), {
            params: {
                day,
                month,
                year,
            },
        })
        .then(({ data }) => {
            months.value = data.months;
            meta.value = data.meta;
        });
};

onMounted(() => {
    getData(props.date);
});

const setDate = ({ day, month, year }) => {
    getData({ day, month, year });
};

const openDate = (day) => {
    emit('setDate', day);
};
</script>
